import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import "core-js/modules/es6.regexp.split.js";

var parseHash = function parseHash(hash) {
  return hash.split('&').reduce(function (acc, item) {
    var currentAcc = acc;
    var parts = item.split('=');

    var _parts = _slicedToArray(parts, 2);

    currentAcc[parts[0]] = _parts[1];
    return currentAcc;
  }, {});
};

export default parseHash;